export const PRIMARY = 'PRIMARY'
export const REGULAR = 'REGULAR'
export const UNCONFIGURED = 'UNCONFIGURED'

export type SequenceType = typeof PRIMARY | typeof REGULAR | typeof UNCONFIGURED
